import { render, staticRenderFns } from "./EcrList.vue?vue&type=template&id=077b24a6"
import script from "./EcrList.vue?vue&type=script&lang=js"
export * from "./EcrList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports